import { configureStore } from "@reduxjs/toolkit";
import handlechart from "./reducer";
import { api } from "./Service/api";
import authReducer from "./Slices/authSlice";

const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    handlechart: handlechart,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});
export default store;
